export default __webpack_public_path__ + "static/logo.svg-bfef05f9542f3b824b1cf075122ece6c.png";